import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Layout,
  message,
  Row,
  Typography,
} from "antd";
import { Descriptions } from "antd/es";
import { getData, postData } from "apiServices/common";
import AppPageHeader from "common/PageHeader";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

const UpdateFoldingToPacking = () => {
  const [details, setDetails] = useState();

  //   Routes
  const navigate = useNavigate();
  const { id } = useParams();

  //   Antd Constants
  const [form] = Form.useForm();

  const handleMismatch = async (id) => {
    try {
      const response = await postData(
        `/api/digitalization/single-date-wise-finishing-update/${id}`,
        {
          status: "mismatch",
        },
      );

      if (response?.code === 200) {
        navigate("/digitalization/packing/folding-to-packing");
        message.success("Details updated successfully");
      }
    } catch (error) {
      message.error("Failed to process mismatch");
    }
  };

  const extra = (
    <div className="extra-button-container">
      <Button
        size="small"
        htmlType="submit"
        style={{ marginRight: 5 }}
        onClick={() => {
          form.resetFields();
          navigate("/digitalization/packing/folding-to-packing");
        }}
      >
        {" "}
        Back
      </Button>
    </div>
  );

  useEffect(() => {
    if (id) {
      const fetchDetails = async () => {
        try {
          const response = await getData(
            `/api/digitalization/single-date-wise-finishing-update-view/${id}`,
            null,
            {},
          );
          const data = response.data?.data;
          setDetails(data);

          form.setFieldsValue({
            sewingEntries: data.garment_finishing_to_packing_details.map(
              (item) => ({
                entry_time: item.entry_time,
                quantity: item.quantity,
                user_id: item.created_by ? `${item.created_by.name}` : "N/A",
              }),
            ),
          });
        } catch (error) {
          message.error("Failed to fetch details");
          setDetails(null);
        }
      };
      fetchDetails();
    }
  }, [id, form]);

  return (
    <>
      <AppPageHeader
        title={
          <Typography.Title level={5}>
            Update Folding To Packing
          </Typography.Title>
        }
        extra={extra}
      />

      <Layout.Content className="item-details">
        <Card
          title="Folding To Packing Details"
          bordered={false}
          style={{ marginTop: 5 }}
        >
          {details && (
            <Descriptions column={4}>
              <Descriptions.Item label="Date">
                {dayjs(details.entry_date).format("YYYY-MM-DD")}
              </Descriptions.Item>
              <Descriptions.Item label="Line">
                {details.line_info?.name || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Buyer">
                {details.buyer_info?.name || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Style">
                {details.style_info?.style_no || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Sub Style">
                {details.sub_style_info?.sub_style_no || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Po Map">
                {details.po_map_info?.original_po || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Color">
                {details.color_info?.name || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Size">
                {details.size_info?.name || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Sales Contract">
                {details.sales_contract_info?.reference_no || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Buying Office">
                {details.buying_office_info?.name || "N/A"}
              </Descriptions.Item>
            </Descriptions>
          )}
        </Card>
        <Card
          title="Entry Details"
          style={{ marginTop: 20, boxShadow: "none" }}
          bordered={false}
        >
          <Form form={form} layout="vertical">
            <Form.List name="sewingEntries">
              {(fields) => (
                <>
                  {fields.map(({ key, name, fieldKey, ...restField }) => (
                    <Card
                      key={key}
                      style={{ marginTop: 10, boxShadow: "none" }}
                    >
                      <Row gutter={24} align="middle">
                        <Col span={4}>
                          <Form.Item
                            {...restField}
                            name={[name, "user_id"]}
                            fieldKey={[fieldKey, "user_id"]}
                            label="Entry By"
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            label="Entry Time"
                            {...restField}
                            name={[name, "entry_time"]}
                            fieldKey={[fieldKey, "entry_time"]}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            {...restField}
                            name={[name, "quantity"]}
                            fieldKey={[fieldKey, "quantity"]}
                            label="Quantity"
                          >
                            <InputNumber
                              style={{
                                width: "100%",
                              }}
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item label=" ">
                            <Button
                              type="primary"
                              danger
                              onClick={() => handleMismatch(id)}
                            >
                              Mismatch
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                </>
              )}
            </Form.List>
          </Form>
        </Card>
      </Layout.Content>
    </>
  );
};

export default UpdateFoldingToPacking;
